import { render, staticRenderFns } from "./step-two.vue?vue&type=template&id=bea34034&scoped=true"
import script from "./step-two.vue?vue&type=script&lang=js"
export * from "./step-two.vue?vue&type=script&lang=js"
import style0 from "./step-two.vue?vue&type=style&index=0&id=bea34034&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea34034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bea34034')) {
      api.createRecord('bea34034', component.options)
    } else {
      api.reload('bea34034', component.options)
    }
    module.hot.accept("./step-two.vue?vue&type=template&id=bea34034&scoped=true", function () {
      api.rerender('bea34034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/step-two.vue"
export default component.exports